// extracted by mini-css-extract-plugin
module.exports = {"info":"info-module--info--2pSdN","imgHero":"info-module--imgHero--DxXf1","logo":"info-module--logo--2o_Uj","flex":"info-module--flex--TZd1e"};